import React from 'react';
import { checkIsMobileBrowser } from '../utils/checkIsMobileBrowser';
import {
  blockScrollDesktop,
  blockScrollMobile,
  restoreScrollDesktop,
  restoreScrollMobile,
} from '../utils/blockScroll';

export function useBlockScroll(shouldBlock, shouldScroll = true) {
  React.useLayoutEffect(() => {
    if (shouldBlock) {
      checkIsMobileBrowser() ? blockScrollMobile() : blockScrollDesktop();
    } else {
      window.setTimeout(() => {
        checkIsMobileBrowser() ? restoreScrollMobile() : restoreScrollDesktop();
      }, 200);
    }
  }, [shouldBlock, shouldScroll]);
}
